module.exports = __webpack_public_path__ + "img/shhou-1.9055e06d.png";